import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import { Store } from '../store'

/**
 * Footer of modal used to deploy Quiver resources
 */
@ngCore.Component({
  imports: [ds.button.Component],
  selector: 'atn-quiver-deployment-modal-footer',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link Store} */
  public readonly store = ngCore.inject(Store)
}
